import { render, staticRenderFns } from "./window.vue?vue&type=template&id=a5acc4e8&scoped=true&"
import script from "./window.vue?vue&type=script&lang=js&"
export * from "./window.vue?vue&type=script&lang=js&"
import style0 from "./window.vue?vue&type=style&index=0&id=a5acc4e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5acc4e8",
  null
  
)

export default component.exports